import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ar_routes, ar_to_en_path } from "../router/ar_routes";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { useSelector } from "react-redux";
import AuthModal from "./AuthModal";
import { CART_UPDATED_EVENT, getCartItems } from "../cart/cartUtils";
import { all_routes } from "../router/all_routes";

const ArabicHeader = () => {
  const routes = ar_routes;
  const location = useLocation();
  const token = useSelector((state: any) => state.auth?.token || "");
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const englishEquivalent = ar_to_en_path[location.pathname] || all_routes.home;

  const header = [
    {
      tittle: "الرئيسية",
      separateRoute: true,
      routes: routes.home,
    },
    {
      tittle: "خدماتنا",
      separateRoute: false,
      menu: [
        { menuValue: "خدمة تاكسي مكة", routes: routes.taxiServiceMakkah },
        { menuValue: "خدمة تاكسي المدينة المنورة", routes: routes.taxiServiceMadinah },
        { menuValue: "خدمة تاكسي مطار جدة", routes: routes.jaddahAirportTaxiService },
        { menuValue: "خدمة النقل من وإلى الفندق", routes: routes.hotelTransport },
        { menuValue: "خدمة النقل من المطار", routes: routes.airportTransfers },
        { menuValue: "خدمة تاكسي الزيارة", routes: routes.ziyaratTaxiService },
      ],
    },
    {
      tittle: "من نحن",
      separateRoute: true,
      routes: routes.about,
    },
    {
      tittle: "الأسئلة الشائعة",
      separateRoute: true,
      routes: routes.faq,
    },
    {
      tittle: "اتصل بنا",
      separateRoute: true,
      routes: routes.contact,
    },
  ];

  useEffect(() => {
    const syncCartCount = () => setCartCount(getCartItems().length);
    syncCartCount();
    window.addEventListener(CART_UPDATED_EVENT, syncCartCount);
    window.addEventListener("storage", syncCartCount);

    return () => {
      window.removeEventListener(CART_UPDATED_EVENT, syncCartCount);
      window.removeEventListener("storage", syncCartCount);
    };
  }, []);

  return (
    <>
      <header className="header">
        <div className="container">
          <nav className="navbar navbar-expand-lg header-nav">
            <div className="navbar-header">
              <Link id="mobile_btn" to="#">
                <span className="bar-icon"></span>
              </Link>
              <Link to={routes.home} className="navbar-brand logo">
                <ImageWithBasePath
                  src="/assets/img/Al-Haramain-Logo-wb.svg"
                  className="img-fluid w-60"
                  alt="الشعار"
                />
              </Link>
              <Link to={routes.home} className="navbar-brand logo-small">
                <ImageWithBasePath
                  src="/assets/img/Al-Haramain-Logo-wb.svg"
                  width={150}
                  alt="الشعار"
                />
              </Link>
            </div>
            <div className="main-menu-wrapper">
              <div className="menu-header">
                <Link to={routes.home} className="menu-logo">
                  <ImageWithBasePath
                    src="/assets/img/Al-Haramain-Logo-wb.svg"
                    className="img-fluid"
                    alt="الشعار"
                  />
                </Link>
                <Link id="menu_close" className="menu-close" to="#">
                  {" "}
                  <i className="fas fa-times" />
                </Link>
              </div>
              <ul className="main-nav">
                {header.map((mainMenus: any, mainIndex) => {
                  const link_array: any = [];
                  mainMenus?.menu?.map((link: any) => {
                    link_array?.push(link?.routes);
                    return link_array;
                  });
                  mainMenus.links = link_array;
                  return (
                    <React.Fragment key={mainIndex}>
                      {mainMenus.separateRoute ? (
                        <li
                          key={mainIndex}
                          className={
                            location.pathname === mainMenus.routes ||
                            mainMenus?.links?.includes(location.pathname)
                              ? "active"
                              : ""
                          }
                        >
                          <Link to={mainMenus.routes}>{mainMenus.tittle}</Link>
                        </li>
                      ) : (
                        <li
                          className={`has-submenu ${
                            mainMenus?.menu
                              ?.map((item: any) => item?.routes)
                              .includes(location.pathname)
                              ? "active"
                              : ""
                          }`}
                        >
                          <Link to="#">
                            {mainMenus.tittle} <i className="fas fa-chevron-down"></i>
                          </Link>
                          <ul className="submenu">
                            {mainMenus.menu?.map((menu: any, menuIndex: any) => (
                              <li
                                key={menuIndex}
                                className={
                                  location.pathname === menu.routes ? "active" : ""
                                }
                              >
                                <Link to={menu.routes}>{menu.menuValue}</Link>
                              </li>
                            ))}
                          </ul>
                        </li>
                      )}
                    </React.Fragment>
                  );
                })}
              </ul>
            </div>
            <ul className="nav header-navbar-rht">
              <li className="nav-item">
                <Link className="nav-link header-cart" to={all_routes.bookingcheckout} aria-label="السلة">
                  <i className="feather-shopping-cart" />
                  {cartCount > 0 && <span>{cartCount}</span>}
                </Link>
              </li>
              <li className="nav-item">
                {token ? (
                  <Link className="nav-link header-login" to={all_routes.dashboard}>
                    <span>
                      <i className="fa-regular fa-user" />
                    </span>
                    حسابي
                  </Link>
                ) : (
                  <button
                    type="button"
                    className="nav-link header-login"
                    onClick={() => setIsAuthModalOpen(true)}
                  >
                    <span>
                      <i className="fa-regular fa-user" />
                    </span>
                    تسجيل الدخول
                  </button>
                )}
              </li>
              <li className="nav-item">
                <Link className="nav-link" to={englishEquivalent}>
                  English
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </header>
      <AuthModal isOpen={isAuthModalOpen} onClose={() => setIsAuthModalOpen(false)} />
    </>
  );
};

export default ArabicHeader;
